import { useState, useEffect } from 'react';
import {
  Users,
  UserPlus,
  Wallet,
  Loader2
} from 'lucide-react';
import api from '../../utils/api';

export default function DashboardTab() {
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalUsers: 0,
    totalChannels: 0,
    todayUsers: 0,
    todayOfficialRechargeOrderCount: 0,
    todayOfficialRechargeAmount: 0,
    todayLy360RechargeOrderCount: 0,
    todayLy360RechargeAmount: 0,
    todayRechargeOrderCount: 0,
    todayRechargeAmount: 0
  });

  useEffect(() => {
    fetchStats();
    const timer = window.setInterval(() => {
      if (document.hidden) {
        return;
      }
      fetchStats({ silent: true });
    }, 60000);

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  const fetchStats = async (options = {}) => {
    const { silent = false } = options;
    try {
      if (!silent) {
        setLoading(true);
      }
      const response = await api.get('/admin/stats');
      if (response.data.success) {
        setStats(response.data.data || response.data);
      }
    } catch (err) {
      console.error('获取统计失败:', err);
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  };

  const businessCards = [
    {
      key: 'totalUsers',
      title: '总用户数',
      value: stats.totalUsers,
      icon: Users,
      iconWrap: 'bg-blue-100 dark:bg-blue-900/30',
      iconColor: 'text-blue-600 dark:text-blue-400'
    },
    {
      key: 'todayUsers',
      title: '今日注册用户数',
      value: stats.todayUsers,
      icon: UserPlus,
      iconWrap: 'bg-indigo-100 dark:bg-indigo-900/30',
      iconColor: 'text-indigo-600 dark:text-indigo-400'
    },
    {
      key: 'todayLy360RechargeOrderCount',
      title: '360支付笔数',
      value: stats.todayLy360RechargeOrderCount,
      detail: `充值金额：¥${Number(stats.todayLy360RechargeAmount || 0).toFixed(2)}`,
      icon: Wallet,
      iconWrap: 'bg-amber-100 dark:bg-amber-900/30',
      iconColor: 'text-amber-600 dark:text-amber-400'
    },
    {
      key: 'todayLy360TopRechargeOrderCount',
      title: '360支付(top)笔数',
      value: stats.todayLy360TopRechargeOrderCount,
      detail: `充值金额：¥${Number(stats.todayLy360TopRechargeAmount || 0).toFixed(2)}`,
      icon: Wallet,
      iconWrap: 'bg-sky-100 dark:bg-sky-900/30',
      iconColor: 'text-sky-600 dark:text-sky-400'
    },
    {
      key: 'todayOfficialRechargeOrderCount',
      title: '官网支付笔数',
      value: stats.todayOfficialRechargeOrderCount,
      detail: `充值金额：¥${Number(stats.todayOfficialRechargeAmount || 0).toFixed(2)}`,
      icon: Wallet,
      iconWrap: 'bg-orange-100 dark:bg-orange-900/30',
      iconColor: 'text-orange-600 dark:text-orange-400'
    }
  ];

  const renderSummaryView = () => (
    <div className="space-y-8">
      <div>
        <h2 className="text-lg font-bold text-gray-900 dark:text-white">业务概览</h2>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">保留原有业务指标，便于辅助判断整体运行情况</p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {businessCards.map((card) => {
          const Icon = card.icon;
          return (
            <div key={card.key} className="rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-700 dark:bg-gray-800">
              <div className="flex items-center gap-4">
                <div className={`flex h-12 w-12 items-center justify-center rounded-xl ${card.iconWrap}`}>
                  <Icon className={`h-6 w-6 ${card.iconColor}`} />
                </div>
                <div>
                  <p className="text-sm text-gray-500 dark:text-gray-400">{card.title}</p>
                  <p className="text-2xl font-bold text-gray-900 dark:text-white">
                    {loading ? <Loader2 className="h-6 w-6 animate-spin text-gray-400" /> : card.value}
                  </p>
                  {card.detail ? (
                    <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{card.detail}</p>
                  ) : null}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );

  return renderSummaryView();
}
